
export enum CustOperationHoursTypeCd {
	DELIVERY_RECEIVING = 'DeliveryReceiving',
	OPERATIONS_GENERAL = 'OperationsGeneral',
	PICKUP_SHIPPING = 'PickupShipping'}

